/**
 * @file: 碗碟架组件初始化操作
 * @author: xiaolong.huang@dmall.com
 */

import * as UIToolkit from '../../UIToolkit/index';
import * as DishrackRenderCore from './renderCore/index';
import { StageEvent } from '../../message/index';

export default function dishrackInit(cube: CubeNode): boolean {
    // 组件与外部通信
    initMessage(cube);

    return true;
}

export function initMessage(cube: CubeNode): void {
    StageEvent.on(['changeRenderMode', 'tagsChangeSetting'], (): void => {
        // 渲染状态切换
        DishrackRenderCore.statusSwitch(cube);
    }, null, cube.id);

    StageEvent.on(['changeSetting'], (): void => {
        // 渲染层板文字
        DishrackRenderCore.renderLayerTxtModel(cube);

        // 渲染警告信息
        UIToolkit.layerWarning(cube);
    }, null, cube.id);
}
